import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { Editor, G6Graph } from './components';
import { FlowChartProps } from './FlowChart.types';

export const CANVAS_Z_INDEX = 1;

export const G6GraphStyled = styled(G6Graph)`
  & canvas {
    z-index: ${CANVAS_Z_INDEX};
    position: absolute;
    top: 0;
    left: 0;
    ::selection {
      color: inherit;
      background-color: transparent;
    }
  }
  .g6-grid-container {
    inset: auto !important;
    user-select: none;
    -webkit-user-select: none;
  }
`;

export const GGEditorStyled = styled(Editor)<FlowChartProps>`
  display: flex;
  user-select: none;
  -webkit-user-select: none;
`;

export const FlowchartWrapper = styled.div<FlowChartProps>`
  user-select: none;
  -webkit-user-select: none;
  position: relative;
  ${({ width }) => width && `width: ${pxToRem(width)}`};
  ${({ height }) => height && `height: ${pxToRem(height)}`};
`;
